import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Heading.module.scss';
import cn from 'classnames';
const Heading = ({ title, className, size = 1, fontWeight = 400, onClick }) => {
    return (_jsx("h2", Object.assign({ onClick: onClick, className: cn(styles.wrapper, className, styles[`hasSize-${size}`], styles[`hasFontWeight-${fontWeight}`]) }, { children: title })));
};
export default Heading;
